import SplunkOtelWeb from '@splunk/otel-web';
import {
  environment
} from './environments/environment';
SplunkOtelWeb.init({
  realm: environment.realm,
  rumAccessToken: environment.rumToken,
  applicationName: "es-toolkitapp",
  deploymentEnvironment: environment.env
});
import {
  enableProdMode
} from '@angular/core';
import {
  platformBrowserDynamic
} from '@angular/platform-browser-dynamic';
import {
  AppModule
} from './app/app.module';

if (environment.production) {
  enableProdMode();
}
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
